import { render, staticRenderFns } from "./Product1.vue?vue&type=template&id=b28c34ec&scoped=true"
import script from "./Product1.vue?vue&type=script&lang=js"
export * from "./Product1.vue?vue&type=script&lang=js"
import style0 from "./Product1.vue?vue&type=style&index=0&id=b28c34ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28c34ec",
  null
  
)

export default component.exports